import { useGetSetting } from "../../../../hooks/getSetting";

/**
 * Hook to check if auto-submit is enabled for the given application form.
 *
 * @param {Object} applicationForm - The application form object.
 * @returns {boolean} Whether auto-submit should be triggered.
 */
const useShouldAutoSubmit = (applicationForm) => {
  const [eeAutoSubmitEnabled] = useGetSetting(["ee.autosubmit-enabled"]);

  if (!applicationForm) return false;

  const isAutoSubmitEnabled = eeAutoSubmitEnabled?.includes(applicationForm?.applicationTemplateName);

  return isAutoSubmitEnabled && applicationForm?.shouldAutoSubmit === true;
};

export { useShouldAutoSubmit };
